import React from 'react';
import styles from './Footer.module.scss';

export const Footer: React.FC = () => {
  const year = new Date().getFullYear();
  return (
    <footer className={styles.footer}>
      &copy; {year} Miistin Co., Ltd. All Rights Reserved.
    </footer>
  );
};
